module.exports = __webpack_public_path__ + "static/media/travel.222c06f6.jpg";